import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BracketButton from '../components/BracketButton';
import { services } from '../mock/mock';

const ServicesPage = () => {
  return (
    <div className="bg-white">
      <Navbar />
      <div className="pt-32 pb-16 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-[1.5px] bg-black/60" />
          <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-black/60">Capabilities</span>
        </div>
        <h1 className="big-display text-[64px] sm:text-[96px] lg:text-[140px] leading-[0.9]">
          Services
          <br />
          <span className="text-black/30">End To End.</span>
        </h1>
        <p className="font-body text-black/70 max-w-2xl mt-6 leading-relaxed">
          Caprock is a full-service trucking and logistics company. Whether you need a single hotshot run tomorrow morning or a full year of dedicated flatbed capacity, we’ve got the equipment and the drivers to move it.
        </p>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-32">
        {services.map((s, i) => (
          <div
            key={s.id}
            id={s.id}
            className={`grid grid-cols-1 lg:grid-cols-12 gap-10 py-16 border-t border-black/10 ${
              i % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''
            }`}
          >
            <div className="lg:col-span-6">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
                />
              </div>
            </div>
            <div className="lg:col-span-6 flex flex-col justify-center">
              <div className="font-mono-tech text-[11px] tracking-[0.3em] uppercase text-black/50 mb-4">
                Service {s.number}
              </div>
              <h2 className="big-display text-[46px] lg:text-[64px] leading-[0.95] mb-5">{s.title}</h2>
              <p className="font-body text-black/75 leading-relaxed mb-8 text-[15px]">{s.description}</p>
              <ul className="space-y-3 mb-10">
                {[
                  '48-state coverage',
                  'Real-time load tracking',
                  'DOT/OSHA compliant equipment',
                  'Dedicated dispatcher per account',
                ].map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-black/80">
                    <span className="mt-2 w-1.5 h-1.5 bg-black" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <div>
                <BracketButton to="/contact" variant="dark">Request Quote</BracketButton>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default ServicesPage;
